// import { axios } from "vue/types/umd";

// import { axios } from "vue/types/umd";

// import { axios } from "vue/types/umd";

export const AdmissionOfficer = {
  namespaced: true,
  state: {
    applicants: [],
    applicant: {},
    applications: [],
  },
  mutations: {
    setApplicants(state, payLoad) {
      state.applicants = payLoad;
    },
    setApplicant(state, payLoad) {
      state.applicant = payLoad;
    },
    setApplications(state, payLoad) {
      state.applications = payLoad;
    },
  },
  actions: {
    // mailing_ware
    sendEmail(context, emailData) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/mailing_ware", emailData)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },

    reset_for_app_adit(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/app/reset/for/edit", details)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },

    reset_application_for_pg_actions(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/pg/adms/action/reset", details)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },

    reset_recommendation_status(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/pgcoord/adms/reset", details)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },
    getApplicants(context) {
      return new Promise((res, rej) => {
        axios
          .post("/admin/getApplicants")
          .then((response) => {
            context.commit("setApplications", response.data.applicants);
            res(response.data.applicants);
          })
          .catch((err) => {
            rej(false);
          });
      });
    },
    getApplications(context, applicationProps) {
      // applicationProps ->status ->fromdate to datedate
      return new Promise((res, rej) => {
        if (
          applicationProps.status != "recommended" &&
          applicationProps.status != "nrecommended"
        ) {
          axios
            .post("/admin/getApplications", {
              status: applicationProps.status,
              deptName: context.rootState.user.deptName,
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res(response.data.applications);
            })
            .catch((err) => {
              rej(false);
            });
        }
        if (applicationProps.status == "nrecommended") {
          axios
            .post("admin/pgcoord/disapproved/recommendation/list", {
              deptName: context.rootState.user.deptName,
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res(response.data.applications);
              return true;
            })
            .catch((err) => {
              rej(false);
              return false;
            });
        }
        if (applicationProps.status == "recommended") {
          axios
            .post("admin/pgcoord/approved/recommendation/list", {
              deptName: context.rootState.user.deptName,
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res(response.data.applications);
              return true;
            })
            .catch((err) => {
              rej(false);
              return false;
            });
        }
      });
    },
    getApplicationGivenEmail(context, applicantEmail) {
      return new Promise((res, rej) => {
        axios
          .post("/admin/getApplicationGivenEmail", applicantEmail)
          .then((response) => {
            context.commit("setApplications", response.data.applications);
            res(response.data.applications);
            return true;
          })
          .catch((err) => {
            rej(false);
            return false;
          });
      });
    },
    getPaginatedApplications(context, applicationProps) {
      return new Promise((res, rej) => {
        // Privileged admins filter freely via the Department/Programme
        // dropdowns, so we must NOT force their own `deptName` scope (it would
        // override the explicit department selection on the backend).
        // Non-privileged users (HOD/Coordinator) keep `deptName` so the server
        // enforces their department scope.
        const privileged = ["SUPERADMIN", "ICT", "ADMIN"];
        const roles = context.rootState.user.roles || [];
        const isPrivileged = roles.some((r) =>
          privileged.includes((r || "").toUpperCase())
        );

        if (
          applicationProps.status != "recommended" &&
          applicationProps.status != "nrecommended"
        ) {
          axios
            .post("/admin/getPaginatedApplications", {
              status: applicationProps.status,
              deptName: isPrivileged ? "" : context.rootState.user.deptName,
              currentPage: applicationProps.currentPage,
              perPage: applicationProps.perPage,
              search: applicationProps.search || "",
              // For non-privileged users (HOD/Coordinator) the department is
              // enforced by name via `deptName`, because their external-portal
              // department id can differ from the DB id. So we only send the
              // resolved `department` id for privileged admins.
              department: isPrivileged ? applicationProps.department || "" : "",
              programme: applicationProps.programme || "",
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res({ applications: response.data.applications, totalRecord: response.data.totalRecord || 0 });
            })
            .catch((err) => {
              rej(err.response ? err.response.data : { error: "Network error" });
            });
        } else if (applicationProps.status == "nrecommended") {
          axios
            .post("admin/pgcoord/disapproved/recommendation/list", {
              deptName: context.rootState.user.deptName,
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res({ applications: response.data.applications, totalRecord: response.data.applications.length });
            })
            .catch((err) => {
              rej({ error: "Failed to load" });
            });
        } else if (applicationProps.status == "recommended") {
          axios
            .post("admin/pgcoord/approved/recommendation/list", {
              deptName: context.rootState.user.deptName,
            })
            .then((response) => {
              context.commit("setApplications", response.data.applications);
              res({ applications: response.data.applications, totalRecord: response.data.applications.length });
            })
            .catch((err) => {
              rej({ error: "Failed to load" });
            });
        }
      });
    },

    recommend_application(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/pgcoord/adms/recommend", details)
          .then((resp) => {
            res(resp);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },

    reject_application(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/pgcoord/adms/reject", details)
          .then((resp) => {
            res(resp);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },

    getApprovedApplications(context, params) {
      console.log(params);
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .get("/admin/get/approved/applications", { params })
          .then((resp) => {
            res(resp.data);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },
    getForms(context, applicationId) {
      return new Promise((res, rej) => {
        axios
          .post("admin/getForms", { applicationId: applicationId })
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    approveAdmission(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("admin/admissionApproved", details)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },
    denyAdmission(context, details) {
      return new Promise((res, rej) => {
        axios
          .post("admin/admissionApproved", details)
          .then((response) => {
            res(response);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
  },
};
